import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Title } from '@/components/ui/title';

/**
 * Pantalla de "no tenés acceso a esto".
 *
 * Antes reusaba `PlaceholderPage`, que dice "Pendiente de implementación" y
 * "En construcción": un usuario sin permiso leía que la sección no existe
 * todavía, cuando en realidad existe y no es para él. Son dos mensajes
 * distintos y la reutilización los confundía.
 *
 * 🔴 NO nombra el permiso interno requerido. Es detalle de implementación y
 * además no le sirve a quien lo lee: lo accionable es a quién pedírselo.
 */
export function NoAccessPage() {
  return (
    <Card className="border-border flex flex-col gap-4 p-6 text-center">
      <div className="flex flex-col gap-1.5">
        <Title role="section" as="h2">
          No tenés acceso a esta sección
        </Title>
        <p className="text-fg-muted text-body">
          Tu cuenta no la tiene habilitada. Si necesitás entrar, pedíselo a
          quien administre los permisos del equipo.
        </p>
      </div>
      <div className="flex justify-center gap-2">
        <Button asChild variant="outline" size="sm">
          <Link to="/dashboard">Ir al inicio</Link>
        </Button>
      </div>
    </Card>
  );
}
